import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Posts from './pages/Posts';
import Products from './pages/Products';
import Contact from './pages/Contact';
import About from './pages/About';
import Campaigns from './pages/Campaigns';
import Help from './pages/Help';
import FAQ from './pages/FAQ';
import EVTireGuide from './pages/EVTireGuide';
import BrandTag from './pages/BrandTag';
import Auth from './pages/Auth';
import CMSPosts from './pages/CMS/Posts';
import CMSCategories from './pages/CMS/Categories';
import CMSProducts from './pages/CMS/Products';
import CMSSiteSettings from './pages/CMS/SiteSettings';
import CMSHome from './pages/CMS/Home';
import PostDetail from './pages/PostDetail';
import ProductDetail from './pages/ProductDetail';
import CMSNewsletter from './pages/CMS/Newsletter';
import CMSContactForm from './pages/CMS/ContactForm';
import { TruckTiresPage, TruckTireDetailPage, TruckTireCategoriesPage } from './pages/TruckTires';
function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />

        {/* Marka Etiket Sayfaları */}
        <Route path='/lassa-lastik' element={<BrandTag />} />
        <Route path='/michelin-lastik' element={<BrandTag />} />
        <Route path='/continental-lastik' element={<BrandTag />} />
        <Route path='/bridgestone-lastik' element={<BrandTag />} />
        <Route path='/pirelli-lastik' element={<BrandTag />} />
        <Route path='/hankook-lastik' element={<BrandTag />} />
        <Route path='/petlas-lastik' element={<BrandTag />} />
        <Route path='/kumho-lastik' element={<BrandTag />} />
        <Route path='/goodyear-lastik' element={<BrandTag />} />
        <Route path='/yokohama-lastik' element={<BrandTag />} />
        <Route path='/falken-lastik' element={<BrandTag />} />
        <Route path='/dunlop-lastik' element={<BrandTag />} />
        <Route path='/nokian-lastik' element={<BrandTag />} />
        <Route path='/starmaxx-lastik' element={<BrandTag />} />
        <Route path='/sava-lastik' element={<BrandTag />} />

        <Route path='/auth' element={<Auth />} />
        <Route path='/blog' element={<Posts />} />
        <Route path='/blog/:id' element={<PostDetail />} />
        <Route path='/lastik' element={<Products />} />
        <Route path='/lastik/:slug' element={<ProductDetail />} />
        <Route path='/products' element={<Products />} />
        <Route path='/products/:slug' element={<ProductDetail />} />

        {/* Kamyon Lastikleri */}
        <Route path='/kamyon-lastikleri' element={<TruckTiresPage />} />
        <Route path='/kamyon-lastikleri/kategoriler' element={<TruckTireCategoriesPage />} />
        <Route path='/kamyon-lastikleri/:id' element={<TruckTireDetailPage />} />

        <Route path='/iletisim' element={<Contact />} />
        <Route path='/hakkimizda' element={<About />} />
        <Route path='/kampanyalar' element={<Campaigns />} />
        <Route path='/yardim' element={<Help />} />
        <Route path='/sss' element={<FAQ />} />
        <Route path='/elektrikli-arac-lastik-rehberi' element={<EVTireGuide />} />
        <Route path='/cms/posts' element={<CMSPosts />} />
        <Route path='/cms/categories' element={<CMSCategories />} />
        <Route path='/cms/products' element={<CMSProducts />} />
        <Route path='/cms/site-settings' element={<CMSSiteSettings />} />
        <Route path='/cms/newsletter' element={<CMSNewsletter />} />
        <Route path='/cms/contact-form' element={<CMSContactForm />} />
        <Route path='/cms/home' element={<CMSHome />} />
        <Route path='/cms/' element={<CMSHome />} />

        {/* Catch-all route - en sonda olmalı */}
        <Route path='*' element={<Home />} />
      </Routes>
    </HelmetProvider>
  );
}

export default React.memo(App);
